
















































import { Component, Prop, Vue } from "vue-property-decorator";
import Metric from "@/employer/components/metric/Metric.vue";
import CommonTabs from "@/employer/components/shared/CommonTabs.vue";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import NoProductOffer from "@/employer/components/metric/NoProductOffer.vue";
import { Config } from "@/shared/config";

@Component({
  components: {
    Metric,
    CommonTabs,
    CommonTab,
    NoProductOffer,
  }
})
export default class MetricTabsWithContent extends Vue {
  @Prop({ required: true }) componentTitle;
  @Prop({ required: true }) accountPlans;
  @Prop({ required: true }) products;
  @Prop({ required: true }) routerUrl;
  @Prop({ required: true }) contentUrl;
  @Prop({ required: true }) employerCode;
  @Prop({ required: true }) accessToken;
  @Prop({ default: false }) showViewMyProgram;
  @Prop({ default: false }) showSeeMore;
  @Prop({ default: false }) useAltButtonStyle;

  tableauUrl = Config.UserServicebaseUri + "/user/tableau";
}
